import 'css-chunksrc/client/pages/notificationsPage/toolBar/styles.scss';export default {
  "toolBar": "_toolBar_15xv0_1",
  "name": "_name_15xv0_7",
  "root": "_root_15xv0_13",
  "listRoot": "_listRoot_15xv0_17",
  "input": "_input_15xv0_25",
  "open": "_open_15xv0_36",
  "body": "_body_15xv0_42",
  "type": "_type_15xv0_48",
  "selected": "_selected_15xv0_57",
  "selection": "_selection_15xv0_61",
  "button": "_button_15xv0_70",
  "icon": "_icon_15xv0_85"
};